"use client";

import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

export const usePaymentSession = (transactionId) => {
  const navigate = useNavigate();
  const hasSubmittedRef = useRef(false);

  // Check if payment was already submitted
  useEffect(() => {
    const paymentSubmitted = sessionStorage.getItem(
      `payment_submitted_${transactionId}`
    );
    if (paymentSubmitted === "true") {
      // Payment was already submitted, redirect to expired page
      navigate(`/payment-expired/${transactionId}`, { replace: true });
    }
  }, [transactionId, navigate]);

  // Mark payment as submitted
  const markPaymentSubmitted = () => {
    hasSubmittedRef.current = true;
    sessionStorage.setItem(`payment_submitted_${transactionId}`, "true");
  };

  // Clear payment session (call this if user cancels or starts over)
  const clearPaymentSession = () => {
    hasSubmittedRef.current = false;
    sessionStorage.removeItem(`payment_submitted_${transactionId}`);
  };

  return {
    markPaymentSubmitted,
    clearPaymentSession,
    hasSubmitted: hasSubmittedRef.current,
  };
};
